export enum ActivityStatus {
  Active = 'active',
  Deleted = 'deleted',
  Deactivated = 'deactivated',
  Completed = 'completed',
}
